/**
 * -----------------------------------------------------------------------------
 * This render menu icon as svg.
 */
export function MenuIcon({ dark = false }: Readonly<{ dark?: boolean }>) {
  const darkClass = dark ? 'stroke-black' : 'stroke-white';
  return (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_898_17548)">
        <path
          className={`stroke-2 ${darkClass}`}
          d="M5 16H27"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className={`stroke-2 ${darkClass}`}
          d="M5 8H27"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className={`stroke-2 ${darkClass}`}
          d="M5 24H27"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_898_17548">
          <rect className="fill-white" height="32" width="32" />
        </clipPath>
      </defs>
    </svg>
  );
}
